module.exports = __webpack_public_path__ + "img/autumn.be5030ca.webp";